module.exports = __webpack_public_path__ + "img/fbApi.35bfa6b0.png";